var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 8 5"}},[_c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.06 0L4 3.09042L0.94 0L0 0.951417L4 5L8 0.951417L7.06 0Z","fill":_vm.color}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }